import * as Sentry from "@sentry/react";
import { shouldDropClientSentryEvent } from "./utils/sentryIgnore";

const SENSITIVE_KEYS = new Set([
  "password",
  "cardinfo",
  "authorization",
  "email",
  "card_number",
  "security_code",
  "cvv",
]);

function redactOneLevel(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, child]) => [
      key,
      SENSITIVE_KEYS.has(key.toLowerCase()) ? "[Redacted]" : child,
    ]),
  );
}

export function redactSentryData(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, child]) => [
      key,
      SENSITIVE_KEYS.has(key.toLowerCase())
        ? "[Redacted]"
        : redactOneLevel(child),
    ]),
  );
}

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    beforeSend(event, hint) {
      if (shouldDropClientSentryEvent(event, hint)) {
        return null;
      }

      const sanitizedEvent = { ...event };
      ["extra", "request", "contexts"].forEach((section) => {
        if (event[section]) {
          sanitizedEvent[section] = redactSentryData(event[section]);
        }
      });
      return sanitizedEvent;
    },
  });
}

export { Sentry };
